// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__1rv30","title":"style_title__12lnt","form":"style_form__1-pUq","input":"style_input__3fCey"};